/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import api from '@utils/api'

import { SET_CATALOG } from '@constants/actionType'

// eslint-disable-next-line import/prefer-default-export
export const getTransactionName = () => async (dispatch, _getState) => {
  const response = await api.getTransactionName()
  if (!response?.status) {
    await dispatch({
      type: SET_CATALOG,
      payload: {nameCatalog: 'transactionNameCatalog', data: response.data}
    })
  }
  return response
}

export const getCategoryByTransactionName = (transactionName) => (dispatch, getState) => {
  const { transactionNameCatalog } = getState().catalogs

  const getCategory = transactionNameCatalog.reduce((category, item) => {
    const hasTransactionName = item.acciones.find(action  => action.transaccion === transactionName)
    if (hasTransactionName) category = item.categoria
    return category
  }, "")
  return getCategory || ''
}

export const sendActionToBitacora = ({reason, transactionName, category = '' }) => async (dispatch, getState) => {
  if (!transactionName) return new Error('[sendActionToBitacora] No se envia transactionName')
  const data = {
    reason,
    transactionName,
    category: category || dispatch(getCategoryByTransactionName(transactionName))
  }
  const response = await api.sendActionToBitacora(data)
  return response
}

export const getSearchBitacora = (querys) => async (dispatch, getState) => {
  const response = await api.getSearchBitacora(querys)
  return response
}




